const bindGlassEffectMixin = (options = { type: 'black', multiple: false }) => {
  return {
    data () {
      return {
        bindInstance: null,
        bindInstanceMap: {}
      }
    },
    methods: {
      bindGlassEffect (el, _options = options, key) {
        const { bindGlassEffect } = window['new-layout-commonComponent']

        if (!options.multiple) {
          if (el && !this.bindInstance) {
            this.bindInstance = bindGlassEffect(el, _options)
          }
        } else if (el && !this.bindInstanceMap[key]) {
          this.bindInstanceMap[key] = bindGlassEffect(el, _options)
        }
      },
      unbindGlassEffect (key) {
        if (options.multiple) {
          this.bindInstanceMap[key] && this.bindInstanceMap[key].unbind()
          delete this.bindInstanceMap[key]
        } else {
          this.bindInstance && this.bindInstance.unbind()
        }
      }
    },
    beforeDestroy () {
      this.unbindGlassEffect()
    }
  }
}

export default bindGlassEffectMixin



// WEBPACK FOOTER //
// ./src/mixins/bindGlassEffectMixin.js